export default Object.freeze({
  BOOKING_CREATE: 'booking.create',
})
